import type { ExternalAction } from '@atlassian/jira-issue-view-store/src/actions/external-actions';
import type { CardId } from '../../../model/types';

export const OPEN_DETAIL_VIEW = 'state.actions.detail-view.OPEN_DETAIL_VIEW' as const;

export type OpenDetailViewAction = {
	type: typeof OPEN_DETAIL_VIEW;
	payload: {
		cardId: CardId;
		externalAction?: ExternalAction;
	};
};

export const openDetailView = (
	cardId: CardId,
	externalAction?: ExternalAction,
): OpenDetailViewAction => ({
	type: OPEN_DETAIL_VIEW,
	payload: {
		cardId,
		externalAction,
	},
});

export const OPEN_DETAIL_VIEW_DEBOUNCED =
	'state.actions.detail-view.OPEN_DETAIL_VIEW_DEBOUNCED' as const;

export type OpenDetailViewDebouncedAction = {
	type: typeof OPEN_DETAIL_VIEW_DEBOUNCED;
	payload: {
		cardId: CardId;
		externalAction?: ExternalAction;
	};
};

export const openDetailViewDebounced = (
	cardId: CardId,
	externalAction?: ExternalAction,
): OpenDetailViewDebouncedAction => ({
	type: OPEN_DETAIL_VIEW_DEBOUNCED,
	payload: {
		cardId,
		externalAction,
	},
});

export const UPDATE_DETAIL_VIEW = 'state.actions.detail-view.UPDATE_DETAIL_VIEW' as const;

export type UpdateDetailViewAction = {
	type: typeof UPDATE_DETAIL_VIEW;
};

export const updateDetailView = (): UpdateDetailViewAction => ({
	type: UPDATE_DETAIL_VIEW,
});

export const CLOSE_DETAIL_VIEW = 'state.actions.detail-view.CLOSE_DETAIL_VIEW' as const;

export type CloseDetailViewAction = {
	type: typeof CLOSE_DETAIL_VIEW;
	payload: {
		issueId: number | undefined;
	};
};

export const closeDetailView = (issueId?: number): CloseDetailViewAction => ({
	type: CLOSE_DETAIL_VIEW,
	payload: {
		issueId,
	},
});

export type Action =
	| OpenDetailViewAction
	| OpenDetailViewDebouncedAction
	| CloseDetailViewAction
	| UpdateDetailViewAction;
